const emptyField = 'Se requiere rellenar este campo!'
const onlyLetters = 'Debe ingresar solo letras!'
const onlyNumbers = 'Sólo se admiten números!'
const indentificationCCValidation = 'La longitud del campo identificación debe ser mayor a 5 y menor que 11'
const indentificationCEValidation = 'La longitud del campo identificación debe ser mayor a 3 y menor que 11'
const onlyUpperLettersAndNumbers = 'Solo se admiten números y letras mayusculas!'
const onlyTenNumbers = 'Se requiere ingresar 10 números!'
const selectType = 'Se requiere seleccionar el tipo de identificación!'
const invalidEmail = 'Email invalido'
const invalidIdentification = 'La cédula no es válida'
const invalidRegionIdentification='Esta cédula no pertenece a ninguna región'
const onlyCCPhone='Se requiere ingresar 09'
const validateBirthday='Se requiere ingresar mayores de edad'
const registerSuccess='registrado correctamente'
const updateSuccess='modificado correctamente'
const validatePasswordLength='Debe tener mas de 8 a 14 caracteres'
const validatePasswordCapitalLetter='Debe tener una mayúscula'
const validatePasswordNumber='Debe tener un número'
const validatePassword='Ingresar contraseña'
const validatePasswords='Las contraseñas no son las mismas'
const termsAndConditions='Debe aceptar los términos y condiciones'
const serverError = "Ocurrio un error por favor comuniquese con el departamento de sistemas";

const claims = "Visualizar reclamos";

const prestacion = " Agregar Prestaciones";
const claimsDocuments = "Visualizar documentos";
const excelExport = "Exportar a excel";
const lupa = "Buscar";
const onlyNumbersAndEndsWith001 = "No es en RUC valido";
const prestacionView = "Prestaciones";
const update = "Actualizar";
const inactive = "Inactivar"
const anular = "Anular"
const approve = "Aprobar";
const view = "Visualizar";
const register = "Registrar";
const pacientes = 'Registrar pacientes'

const orderlaboratory = 'Generar orden de laboratorio'

const orderlaboratoryError = 'Visualizar error'
const orderlaboratoryManual = 'Agregar manualmente orden SynLab'
const orderlaboratoryResultManual = 'Subir manualmente el resultado de laboratorio'

const updateButton = 'Actualizar'
const inactiveButton = 'Inactivar'
const registerCredit = 'Registrar Abono'

const procedimientosGenerales = 'Procedimientos Generales'
const antecedentes = 'Antecedentes'
const agregarProcedimiento = 'Agregar Procedimiento'
const procedimientosDelDiente = 'Procedimientos del Diente'
const validateMessages = {
    registerCredit,
    updateButton,
    inactiveButton,
    orderlaboratoryManual,
    orderlaboratoryError,
    lupa,
    excelExport,
    claimsDocuments,
    emptyField,
    onlyLetters,
    onlyNumbers,
    indentificationCCValidation,
    onlyUpperLettersAndNumbers,
    indentificationCEValidation,
    onlyTenNumbers,
    invalidEmail,
    selectType,
    invalidIdentification,
    invalidRegionIdentification,
    onlyCCPhone,validateBirthday,
    registerSuccess,
    updateSuccess,
    validatePasswordLength,
    validatePasswordCapitalLetter,
    validatePasswordNumber,
    validatePassword,
    validatePasswords,
    termsAndConditions,
    serverError,
    claims,
    onlyNumbersAndEndsWith001,
    prestacion,
    inactive,
    prestacionView,
    update,
    anular,
    approve,
    view,
    register,
    pacientes,
    orderlaboratory,
    orderlaboratoryResultManual,
    procedimientosGenerales,
    antecedentes,
    agregarProcedimiento,
    procedimientosDelDiente


};

export default validateMessages;